import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import { createReportTemplate, editReportTemplateById } from '../actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { getFirstFormError, getResponseError, setFormError } from '../../../utils/utils';
import ReportTemplateDTO from '../../../dto/ReportTemplateDTO';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import MultipleSelectInput from '../../../components/fields/SelectInput/MultipleSelectInput';

export default function ReportTemplateForm(props) {
  const {
    close = () => {},
    loadData = () => {},
    current = {},
    isEdit = false,
  } = props;
  const dispatch = useDispatch();
  const {
    control,
    getValues,
    formState: { errors },
    setError,
    setFocus,
  } = useForm({
    mode: 'onChange',
    defaultValues: isEdit ? current : {},
  });

  const handleSave = () => {
    const error = getFirstFormError(errors);
    if (error) {
      errorNotification('Сохранение формы МАИС ЭГУ', 'Ошибка заполнения формы');
      const { ref } = error;
      if (ref && ref.name) {
        setFocus(ref.name);
      }
      return null;
    }
    const values = getValues();
    const action = isEdit ? editReportTemplateById : createReportTemplate;
    dispatch(action({ ...values, id: current.id }))
      .then(() => {
        loadData();
        close();
        successNotification('Сохранение формы МАИС ЭГУ', 'Форма сохранена');
      })
      .catch(response => {
        setFormError(response, setError);
        errorNotification('Сохранение формы МАИС ЭГУ', getResponseError({ error: response && response.message ? response.message : '' }));
      });
  };

  const DTO = new ReportTemplateDTO();
  const attributes = DTO.getAttributesByName();

  return (
    <Dialog
      className="application-denied-dialog"
      onClose={close}
      open
    >
      <DialogTitle header={isEdit ? 'Редактирование шаблона запроса' : 'Создание шаблона запроса'} title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="application-denied-content">
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.data}
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.source}
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.service}
            variant="material"
          />
        </Row>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-buttons">
          <Button className="hff-clear-show" type="submit" onClick={handleSave}>Сохранить</Button>
          <Button className="hff-clear-data" variant="secondary" onClick={close}>Отменить</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
